export default __webpack_public_path__ + "8f2680d831f15a85f886573d5530d522.png";